import { grey } from '@mui/material/colors';
import * as React from 'react';
import * as Redux from 'react-redux';
import { formatHoraHorarioHelper } from '../../../../../helpers';

// En la data del evento debe reflejarse el "rowspan" como block: que seria bloques unidos

function VistaPreviaEntHorarioClasesComponent({ type = 1, docentes }) {
  const entHorDiasStore = Redux.useSelector((state) => state.entHorDias);
  const entHorBloquesStore = Redux.useSelector((state) => state.entHorBloques);

  const header = [
    {
      id: 0,
      dia: 'HORAS',
      abrev: 'H',
      num: 0,
    },
    ...entHorDiasStore.all,
  ];

  const tablaDefault = (
    <table border={3} width="70%" align="center">
      <thead>
        <tr>
          {header.map((dia, index) => (
            <th key={`${dia}_${index}`} align="center">
              {dia.dia}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {entHorBloquesStore.all.map((bloque, index) => (
          <tr key={bloque.id}>
            <td
              width="200px"
              align="center"
              style={{ backgroundColor: bloque.break ? grey[400] : 'white' }}
            >
              {formatHoraHorarioHelper(bloque.start)} -{' '}
              {formatHoraHorarioHelper(bloque.end)}
            </td>
            {entHorDiasStore.all.map((dia, i) => (
              <td
                align="center"
                width="200px"
                rowspan="1"
                style={{ backgroundColor: bloque.break ? grey[400] : 'white' }}
                key={`block-${index}${i}`}
              >
                {bloque.break ? 'Libre' : `${dia.num}:${bloque.num}`}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );

  function getHorariosRandom() {
    switch (type) {
      case 1: // Secciones
        break;
      case 2: // Docentes
        break;

      default:
        break;
    }

    return <h1>Horario</h1>;
  }

  return docentes ? getHorariosRandom() : tablaDefault;
}

export default VistaPreviaEntHorarioClasesComponent;
